/**
 * Open Razorpay checkout, or, when the server runs in TEST_MODE (the order
 * came back with test_mode: true), skip the popup and settle straight away:
 * the server's verify endpoint skips the signature check in TEST_MODE.
 *
 * @param {object} options Razorpay checkout options (needs order_id + handler)
 * @param {boolean} testMode the order's `test_mode` flag from the server
 */
export function openCheckout(options, testMode) {
  if (testMode) {
    return options.handler({
      razorpay_order_id: options.order_id,
      razorpay_payment_id: 'test_payment',
      razorpay_signature: 'test_mode',
    });
  }
  return new window.Razorpay(options).open();
}
